"use client";
import { useIntl } from "@amazeelabs/react-intl";
import { FrameQuery, Link } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import { isTruthy } from "../../utils/isTruthy";
import { buildNavigationTree } from "../../utils/navigation";
import { useOperation } from "../../utils/operation";
import { FacebookLogo, InstagramLogo } from "../Atoms/Logos";
var socialLogosMap = {
    Facebook: FacebookLogo,
    Instagram: InstagramLogo
};
function useFooterNavigation() {
    var lang = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "en";
    var data = useOperation(FrameQuery).data;
    var buildNavItems = function(navItems) {
        var _navItems_filter_pop;
        return (navItems === null || navItems === void 0 ? void 0 : (_navItems_filter_pop = navItems.filter(function(nav) {
            return (nav === null || nav === void 0 ? void 0 : nav.locale) === lang;
        }).pop()) === null || _navItems_filter_pop === void 0 ? void 0 : _navItems_filter_pop.items.filter(isTruthy)) || [];
    };
    return {
        preFooter: buildNavItems(data === null || data === void 0 ? void 0 : data.preFooterNavigation),
        social: buildNavItems(data === null || data === void 0 ? void 0 : data.socialNavigation),
        partners: buildNavItems(data === null || data === void 0 ? void 0 : data.partnersNavigation),
        paymentOptions: buildNavItems(data === null || data === void 0 ? void 0 : data.paymentOptionsNavigation),
        legal: buildNavItems(data === null || data === void 0 ? void 0 : data.legalNavigation)
    };
}
export function Footer() {
    return /*#__PURE__*/ React.createElement("footer", {
        id: "footer",
        className: "mt-10"
    }, /*#__PURE__*/ React.createElement("nav", {
        "aria-label": "Footer"
    }, /*#__PURE__*/ React.createElement(FooterMainNav, null), /*#__PURE__*/ React.createElement(FooterPartnerSection, null), /*#__PURE__*/ React.createElement(FooterLegalSection, null)));
}
export function FooterMainNav() {
    var intl = useIntl();
    var _useFooterNavigation = useFooterNavigation(intl.locale), preFooter = _useFooterNavigation.preFooter, social = _useFooterNavigation.social;
    var preFooterNavItems = buildNavigationTree(preFooter);
    var socialNavItems = buildNavigationTree(social);
    return /*#__PURE__*/ React.createElement("div", {
        className: "container-page bg-theme-dark"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "sr-only"
    }, intl.formatMessage({
        defaultMessage: "Pre Footer",
        id: "baEwA1"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "container-content flex flex-col py-8 lg:py-20 lg:gap-16"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "!pl-0 grid grid-cols-[repeat(auto-fit,minmax(min(100%,170px),1fr))] gap-y-10 gap-x-6 lg:gap-x-10 justify-between lg:justify-start"
    }, preFooterNavItems.map(function(item, key) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            key: key + "pre-footer",
            className: "block w-full mb-3"
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "text-theme-light text-xs leading-snug font-bold uppercase mb-6 leading-trim",
            id: "pre-footer-list-label-".concat(key)
        }, item.title), /*#__PURE__*/ React.createElement("ul", {
            className: "flex flex-col gap-6 !my-0",
            "aria-labelledby": "pre-footer-list-label-".concat(key)
        }, item.children.length > 0 ? item.children.map(function(child) {
            return /*#__PURE__*/ React.createElement("li", {
                key: child.target
            }, /*#__PURE__*/ React.createElement(Link, {
                href: child.target || "/",
                className: "text-base lg:text-sm leading-normal font-bold block hover:underline w-fit text-white leading-trim"
            }, child.title));
        }) : null)));
    }), socialNavItems.map(function(item, key) {
        return /*#__PURE__*/ React.createElement("div", {
            key: key + "social",
            className: "block w-full mb-3"
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "text-theme-light text-xs leading-snug font-bold uppercase mb-4 lg:mb-7 leading-trim",
            id: "social-list-label-".concat(key)
        }, item.title), /*#__PURE__*/ React.createElement("ul", {
            className: "flex flex-row gap-5 !my-0 items-center",
            "aria-labelledby": "social-list-label-".concat(key)
        }, item.children.length > 0 ? item.children.map(function(child) {
            var SocialLogo = socialLogosMap[child.title];
            return /*#__PURE__*/ React.createElement("li", {
                key: child.target
            }, /*#__PURE__*/ React.createElement(Link, {
                href: child.target || "/",
                className: "text-sm leading-normal font-bold block hover:underline w-fit"
            }, SocialLogo && /*#__PURE__*/ React.createElement(SocialLogo, null)));
        }) : null));
    }))));
}
export function FooterPartnerSection() {
    var intl = useIntl();
    var _useFooterNavigation = useFooterNavigation(intl.locale), partners = _useFooterNavigation.partners, paymentOptions = _useFooterNavigation.paymentOptions;
    if (partners.length == 0 && paymentOptions.length == 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "container-page bg-blue-grey-3 py-8 lg:py-16"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "sr-only"
    }, intl.formatMessage({
        defaultMessage: "Footer",
        id: "Vge+RX"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("!pl-0 grid grid-cols-1 sm:grid-cols-2 gap-y-10 gap-x-6 lg:gap-x-10 justify-between lg:justify-start", {
            "sm:!grid-cols-1": partners.length == 0 || paymentOptions.length == 0
        })
    }, partners.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "block w-full mb-3"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-theme-dark text-xs leading-snug font-bold uppercase mb-4 leading-trim",
        id: "partners-list-label"
    }, intl.formatMessage({
        defaultMessage: "Partner",
        id: "MToUjW"
    })), /*#__PURE__*/ React.createElement("ul", {
        className: "flex flex-row gap-5 flex-wrap !my-0 items-center",
        "aria-labelledby": "partners-list-label"
    }, partners.map(function(partner, key) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, partner.target && partner.logoUrl && /*#__PURE__*/ React.createElement("li", {
            key: key
        }, /*#__PURE__*/ React.createElement(Link, {
            href: partner.target,
            className: "text-sm leading-normal font-bold block hover:underline w-fit"
        }, /*#__PURE__*/ React.createElement("img", {
            src: partner.logoUrl,
            alt: partner.title,
            className: "max-h-[3.125rem] w-auto"
        }))));
    }))), paymentOptions.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "block w-full mb-3"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-theme-dark text-xs leading-snug font-bold uppercase mb-4 leading-trim",
        id: "payments-list-label"
    }, intl.formatMessage({
        defaultMessage: "Payment options",
        id: "fde27w"
    })), /*#__PURE__*/ React.createElement("ul", {
        className: "flex flex-row flex-wrap gap-4 !my-0 items-center",
        "aria-labelledby": "payments-list-label"
    }, paymentOptions.map(function(paymentOption, key) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, paymentOption.logoUrl && /*#__PURE__*/ React.createElement(React.Fragment, null, paymentOption.target && paymentOption.target !== "" ? /*#__PURE__*/ React.createElement("li", {
            key: key
        }, /*#__PURE__*/ React.createElement(Link, {
            href: paymentOption.target,
            className: "text-sm leading-normal font-bold block hover:underline w-fit"
        }, /*#__PURE__*/ React.createElement("img", {
            src: paymentOption.logoUrl,
            alt: paymentOption.title,
            className: "max-h-[3.125rem] w-auto"
        }))) : /*#__PURE__*/ React.createElement("li", {
            key: key
        }, /*#__PURE__*/ React.createElement("img", {
            src: paymentOption.logoUrl,
            alt: paymentOption.title,
            className: "max-h-[3.125rem] w-auto"
        }))));
    }))))));
}
export function FooterLegalSection() {
    var intl = useIntl();
    var legal = useFooterNavigation(intl.locale).legal;
    return /*#__PURE__*/ React.createElement("div", {
        className: "container-page bg-black"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content pt-8 pb-14 md:py-15 flex flex-col md:flex-row justify-between gap-10"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "text-sm leading-snug text-white font-light leading-trim",
        "data-chromatic": "ignore"
    }, "\xa9 ", new Date().getFullYear(), " ", intl.formatMessage({
        defaultMessage: "Touring Club Schweiz",
        id: "TyWx3t"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "sr-only",
        id: "legal-list-label"
    }, " ", intl.formatMessage({
        defaultMessage: "Legal Navigation",
        id: "wSTT6G"
    })), /*#__PURE__*/ React.createElement("ul", {
        className: "flex flex-col md:flex-row flex-wrap gap-x-4  gap-y-6 items-start",
        "aria-labelledby": "legal-list-label"
    }, legal.map(function(item, key) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, item.target && item.target !== "" ? /*#__PURE__*/ React.createElement("li", {
            key: key
        }, /*#__PURE__*/ React.createElement(Link, {
            href: item.target,
            className: "text-sm leading-normal font-light hover:underline w-fit leading-trim text-white block"
        }, item.title)) : /*#__PURE__*/ React.createElement(React.Fragment, null));
    }), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        href: "#",
        onClick: function(e) {
            if (typeof window !== "undefined" && window.UC_UI) {
                window.UC_UI.showSecondLayer();
            }
            e.preventDefault();
        },
        className: "text-sm leading-normal font-light hover:underline w-fit leading-trim text-white block"
    }, intl.formatMessage({
        defaultMessage: "Cookie settings",
        id: "KS0bwV"
    }))))));
}
